import type { EnumUnion } from '@dresscode-frontend/utility-types';
import { z } from 'zod';
import type { CategoryCounts, LicenseAssignmentCategory } from './-api/type';

// ソート可能なカラム (USER_BASED用) - APIのorderByに対応
const SortableColumns = {
  LICENSE_PRODUCT: 'LICENSE_PRODUCT',
  WORKER_NAME: 'WORKER_NAME',
  APP_USER_NAME: 'APP_USER_NAME',
  CALCULATED_AT: 'CALCULATED_AT'
} as const;
export type SortableColumns = EnumUnion<typeof SortableColumns>;

// テーブルのカラムIDとAPIのorderByのマッピング
export const columnToOrderBy: Record<string, SortableColumns | undefined> = {
  user: SortableColumns.APP_USER_NAME,
  worker: SortableColumns.WORKER_NAME
} as const;

// DEVICE_BASED用のカテゴリ（レガシー）
const LicenseDeviceCategoryFilterKey = {
  ASSIGNED: 'ASSIGNED'
} as const;

// USER_BASED用のカテゴリ
export const USER_BASED_CATEGORY = {
  FOLLOWING: 'FOLLOWING',
  NO_LICENSE: 'NO_LICENSE',
  VIOLATED: 'VIOLATED',
  VIOLATED_SUBGROUP: 'VIOLATED_SUBGROUP',
  ALUMNI: 'ALUMNI',
  ALL: 'ALL'
} as const satisfies Record<string, LicenseAssignmentCategory>;
export type UserBasedCategory = EnumUnion<typeof USER_BASED_CATEGORY>;

// カテゴリカウントの空データ（VIOLATED_SUBGROUPは意図的に未定義）
export const EMPTY_CATEGORY_COUNTS: CategoryCounts = {
  FOLLOWING: 0,
  NO_LICENSE: 0,
  VIOLATED: 0,
  ALUMNI: 0,
  ALL: 0
};

// タブのキー（DEVICE_BASED用）
export const TabKey = {
  ASSIGNED: LicenseDeviceCategoryFilterKey.ASSIGNED
} as const;
export type TabKey = EnumUnion<typeof TabKey>;

// USER_BASED用のSearchSchema
const UserBasedCategorySchema = z.enum([USER_BASED_CATEGORY.FOLLOWING, USER_BASED_CATEGORY.NO_LICENSE, USER_BASED_CATEGORY.VIOLATED, USER_BASED_CATEGORY.VIOLATED_SUBGROUP, USER_BASED_CATEGORY.ALUMNI, USER_BASED_CATEGORY.ALL]);
export const SearchSchema = z.object({
  sortOrder: z.enum(['asc', 'desc']).optional(),
  category: UserBasedCategorySchema.default(USER_BASED_CATEGORY.FOLLOWING),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: z.string().optional()
});